/** CPF: 11 dígitos com dois dígitos verificadores em módulo 11. */

const COMPRIMENTO_CPF = 11;

/** Todos os 11 dígitos iguais (`11111111111`, `00000000000`, …). */
const TODOS_IGUAIS = /^(\d)\1{10}$/;

const MASCARA_CPF = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;

/** Remove tudo que não for dígito. */
export function normalizarCpf(valor: string): string {
  return valor.replace(/\D/g, '');
}

/**
 * Módulo 11 clássico: pesos decrescentes a partir de `pesoInicial`,
 * resto < 2 ⇒ dígito 0, senão 11 − resto.
 */
function calcularDigito(base: string, pesoInicial: number): number {
  let soma = 0;
  for (let indice = 0; indice < base.length; indice += 1) {
    soma += Number(base.charAt(indice)) * (pesoInicial - indice);
  }
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

/** Valida um CPF pelos dígitos verificadores, rejeitando os 11 dígitos repetidos. */
export function validarCpf(valor: string): boolean {
  const cpf = normalizarCpf(valor);

  if (cpf.length !== COMPRIMENTO_CPF) return false;
  if (TODOS_IGUAIS.test(cpf)) return false;

  const base = cpf.slice(0, 9);
  const dv1 = calcularDigito(base, 10);
  const dv2 = calcularDigito(`${base}${dv1}`, 11);

  return cpf.slice(9) === `${dv1}${dv2}`;
}

/**
 * Formata como `000.000.000-00`.
 *
 * Se o valor normalizado não tiver 11 dígitos, devolve o valor normalizado sem máscara.
 */
export function formatarCpf(valor: string): string {
  const cpf = normalizarCpf(valor);
  if (cpf.length !== COMPRIMENTO_CPF) return cpf;
  return cpf.replace(MASCARA_CPF, '$1.$2.$3-$4');
}
